import { List } from 'immutable';
import { lruMemoize } from 'reselect';

const isSystemAndTechTaxonomyLoading = lruMemoize(
    (data) => data.get('loaded') === 'loading',
);

const getSystemAndTechTaxonomyCategories = lruMemoize(
    (data) => data.getIn(['catSystemAndTech', 'categories'], List()),
);

export {
    isSystemAndTechTaxonomyLoading,
    getSystemAndTechTaxonomyCategories,
};
